import { z } from "zod";

export const supplierIdentitySchema = z.object({
  taxId: z.string().trim().max(64),
  taxCountryCode: z.string().trim().regex(/^[a-zA-Z]{2}$/).transform((value) => value.toUpperCase()).default("ES"),
});

export const supplierContactSchema = z.object({
  person: z.string().trim().max(255).optional().nullable(),
  role: z.string().trim().max(100).optional().nullable(),
  email: z.string().trim().max(320).optional().nullable(),
  phone: z.string().trim().max(64).optional().nullable(),
});
export const supplierContactsSchema = z.array(supplierContactSchema).max(20).optional();
export type SupplierContact = z.infer<typeof supplierContactSchema>;

export const supplierInputSchema = supplierIdentitySchema.extend({
  name: z.string().trim().min(1).max(255),
  email: z.string().trim().max(320).optional().nullable(),
  phone: z.string().trim().max(64).optional().nullable(),
  contactName: z.string().trim().max(255).optional().nullable(),
  contactPerson: z.string().trim().max(255).optional().nullable(),
  contactRole: z.string().trim().max(100).optional().nullable(),
  contacts: supplierContactsSchema,
  notes: z.string().trim().optional().nullable(),
  reusePartnerId: z.number().int().positive().optional(),
  consentReuse: z.boolean().default(false),
  /** Rejects an already-existing supplier profile when invoked from the supplier directory. */
  rejectExistingSupplier: z.boolean().optional(),
  active: z.boolean().optional(),
});

export type FinanceSupplierListItem = {
  id: number;
  name: string;
  taxId: string | null;
  email: string | null;
  phone: string | null;
  contactName: string | null;
  contactPerson: string | null;
  contactRole: string | null;
  notes: string | null;
  active: boolean;
  businessPartnerId: number | null;
  taxCountryCode: string | null;
  partnerCode: string | null;
  legalName: string | null;
  contacts: SupplierContact[];
};

export type SupplierInput = z.infer<typeof supplierInputSchema>;
export type SupplierIdentityInput = z.infer<typeof supplierIdentitySchema>;
export type SupplierIdentityResult = {
  kind: "new" | "existing_supplier" | "existing_partner" | "review_required";
  reason?: string;
  partnerId?: number;
  supplierId?: number;
  name?: string;
  isCustomer?: boolean;
};

/** Selection is deliberately a partial update: never reset the invoice draft/File. */
export function selectSupplierInDraft<T extends { supplierId: string }>(draft: T, supplierId: number): T {
  return { ...draft, supplierId: String(supplierId) };
}

